let width = 10;
let bombAmount = 10;
let flags = 0;
let squares = [];
let isGameOver = false;
let totLifes = 3;

let grid;
let flagsLeft;
let result; 
let lifes;

const PRICE = 5;

function onLongPress(element, callback) {
  var timeoutId;

  element.addEventListener('touchstart', function(e) {
      timeoutId = setTimeout(function() {
          timeoutId = null;
          e.stopPropagation();
          callback(e.target);
      }, 500);
  });

  element.addEventListener('contextmenu', function(e) {
      e.preventDefault();
  });

  element.addEventListener('touchend', function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
        click(element);
      }
  });

  element.addEventListener('touchmove', function () {
      if (timeoutId) clearTimeout(timeoutId);
  });

  element.addEventListener('click', function(e) {
      click(element);
  })
}

function init() {
  grid = document.querySelector('.minesweeper-grid')
  flagsLeft = document.querySelector('#minesweeper-flags-left')
  result = document.querySelector('#minesweeper-result')
  lifes = document.querySelector('#minesweeper-lifes')

  flags = 0;
  squares = [];
  isGameOver = false;
  totLifes = 3;
  result.innerHTML = '';
  flagsLeft.innerHTML = bombAmount
  displayLifes(totLifes);
}

//create Board
function createBoard() {
  init();

  //get shuffled game array with random bombs
  const bombsArray = Array(bombAmount).fill('minesweeper-bomb')
  const emptyArray = Array(width*width - bombAmount).fill('minesweeper-valid')
  const gameArray = emptyArray.concat(bombsArray)
  const shuffledArray = gameArray.sort(() => Math.random() -0.5)

  grid.innerHTML = ""; 
  for(let i = 0; i < width*width; i++) {
    const square = document.createElement('div')
    square.setAttribute('id', i)
    square.classList.add(shuffledArray[i])
    grid.appendChild(square)
    squares.push(square)

    ////normal click
    //square.addEventListener('click', function(e) {
    //  click(square)
    //})
//
    ////cntrl and left click
    //square.oncontextmenu = function(e) {
    //  e.preventDefault()
    //  addFlag(square)
    //}

    onLongPress(square, function(e) {
      e.preventDefault()
      addFlag(square)
    });
  }

  //add numbers
  for (let i = 0; i < squares.length; i++) {
    let total = 0
    const isLeftEdge = (i % width === 0)
    const isRightEdge = (i % width === width -1)

    if (squares[i].classList.contains('minesweeper-valid')) {
      if (i > 0 && !isLeftEdge && squares[i -1].classList.contains('minesweeper-bomb')) total ++
      if (i > 9 && !isRightEdge && squares[i +1 -width].classList.contains('minesweeper-bomb')) total ++
      if (i > 10 && squares[i -width].classList.contains('minesweeper-bomb')) total ++
      if (i > 11 && !isLeftEdge && squares[i -1 -width].classList.contains('minesweeper-bomb')) total ++
      if (i < 98 && !isRightEdge && squares[i +1].classList.contains('minesweeper-bomb')) total ++
      if (i < 90 && !isLeftEdge && squares[i -1 +width].classList.contains('minesweeper-bomb')) total ++
      if (i < 88 && !isRightEdge && squares[i +1 +width].classList.contains('minesweeper-bomb')) total ++
      if (i < 89 && squares[i +width].classList.contains('minesweeper-bomb')) total ++
      squares[i].setAttribute('data', total)
    }
  }
}

function displayLifes(val) {
  if (val != null) {
    let str = "";
    for (let i=0; i<val; i++) {
      str = str + '☕️ ';
    }
    //lifes.innerHTML = " (" + val + " vite)";
    lifes.innerHTML = str;
  } else {
    lifes.innerHTML = "";
  }
}

//add Flag with right click
function addFlag(square) {
  if (isGameOver) return
  if (!square.classList.contains('minesweeper-checked') && (flags < bombAmount)) {
    if (!square.classList.contains('minesweeper-flag')) {
      square.classList.add('minesweeper-flag')
      square.innerHTML = '📍'; //'🚩'
      flags ++
      flagsLeft.innerHTML = bombAmount- flags
      checkForWin()
    } else {
      square.classList.remove('minesweeper-flag')
      square.innerHTML = ''
      flags --
      flagsLeft.innerHTML = bombAmount- flags
    }
  }
}

//click on square actions
function click(square) {
  console.debug("Click");
  clickHandler(square);
  checkForWin();
}

function clickHandler(square) {
  let currentId = square.id
  if (isGameOver) return
  if (square.classList.contains('minesweeper-checked') || square.classList.contains('minesweeper-flag')) return
  if (square.classList.contains('minesweeper-bomb')) {
    hitBomb(square)
  } else {
    let total = square.getAttribute('data')
    if (total !=0) {
      square.classList.add('minesweeper-checked')
      if (total == 1) square.classList.add('minesweeper-one')
      if (total == 2) square.classList.add('minesweeper-two')
      if (total == 3) square.classList.add('minesweeper-three')
      if (total == 4) square.classList.add('minesweeper-four')
      if (total == 5) square.classList.add('minesweeper-five')
      if (total == 6) square.classList.add('minesweeper-six')
      if (total == 7) square.classList.add('minesweeper-seven')
      if (total == 8) square.classList.add('minesweeper-eigth')
      square.innerHTML = total
      return
    }
    checkSquare(square, currentId)
  }
  square.classList.add('minesweeper-checked');
}


//check neighboring squares once square is clicked
function checkSquare(square, currentId) {
  const isLeftEdge = (currentId % width === 0)
  const isRightEdge = (currentId % width === width -1)

  setTimeout(() => {
    if (currentId > 0 && !isLeftEdge) {
      const newId = squares[parseInt(currentId) -1].id
      //const newId = parseInt(currentId) - 1   ....refactor
      const newSquare = document.getElementById(newId)
      clickHandler(newSquare)
    }
    if (currentId > 9 && !isRightEdge) {
      const newId = squares[parseInt(currentId) +1 -width].id
      //const newId = parseInt(currentId) +1 -width   ....refactor
      const newSquare = document.getElementById(newId)
      clickHandler(newSquare)
    }
    if (currentId > 10) {
      const newId = squares[parseInt(currentId -width)].id
      //const newId = parseInt(currentId) -width   ....refactor
      const newSquare = document.getElementById(newId)
      clickHandler(newSquare)
    }
    if (currentId > 11 && !isLeftEdge) {
      const newId = squares[parseInt(currentId) -1 -width].id
      //const newId = parseInt(currentId) -1 -width   ....refactor
      const newSquare = document.getElementById(newId)
      clickHandler(newSquare)
    }
    if (currentId < 98 && !isRightEdge) {
      const newId = squares[parseInt(currentId) +1].id
      //const newId = parseInt(currentId) +1   ....refactor
      const newSquare = document.getElementById(newId)
      clickHandler(newSquare)
    }
    if (currentId < 90 && !isLeftEdge) {
      const newId = squares[parseInt(currentId) -1 +width].id
      //const newId = parseInt(currentId) -1 +width   ....refactor
      const newSquare = document.getElementById(newId)
      clickHandler(newSquare)
    }
    if (currentId < 88 && !isRightEdge) {
      const newId = squares[parseInt(currentId) +1 +width].id
      //const newId = parseInt(currentId) +1 +width   ....refactor
      const newSquare = document.getElementById(newId)
      clickHandler(newSquare)
    }
    if (currentId < 89) {
      const newId = squares[parseInt(currentId) +width].id
      //const newId = parseInt(currentId) +width   ....refactor
      const newSquare = document.getElementById(newId)
      clickHandler(newSquare)
    }
  }, 10)
}


function hitBomb(square) {
  if (totLifes > 0) {
    const audio = new Audio(import.meta.env.VITE_SCOPE + 'snap.mp3');
    audio.play();

    square.innerHTML = '☕️'
    square.classList.remove('minesweeper-bomb')
    square.classList.add('minesweeper-checked')
    square.classList.add('minesweeper-lost')
    totLifes--;
    displayLifes(totLifes);
  } else {
    totLifes--;
    displayLifes(null);
    gameOver(square);
  }
}

//game over
function gameOver(square) {
  result.innerHTML = 'BOOM! Game Over!'
  isGameOver = true

  //show ALL the bombs
  squares.forEach(square => {
    if (square.classList.contains('minesweeper-bomb')) {
      square.innerHTML = '☕️'
      square.classList.remove('minesweeper-bomb')
      square.classList.add('minesweeper-checked')
    }
  })

  const audio = new Audio(import.meta.env.VITE_SCOPE + 'bomb.mp3');
  audio.play();
}

//check for win
function checkForWin() {
  ///simplified win argument
  //let matches = 0
  //
  //for (let i = 0; i < squares.length; i++) {
  //  if (squares[i].classList.contains('minesweeper-flag') && squares[i].classList.contains('minesweeper-bomb')) {
  //    matches ++
  //  }
  //  if (matches === bombAmount) {
  //    result.innerHTML = 'YOU WIN!'
  //    isGameOver = true
  //  }
  //}
  if (isGameOver) return 
  
  let notChecked = 0;
  for (let i = 0; i < squares.length; i++) {
    if (!squares[i].classList.contains('minesweeper-checked')) {
      notChecked ++;
    } else if (squares[i].classList.contains('minesweeper-lost')) {
      notChecked ++;
    }
  }

  console.debug("notChecked (%d)", notChecked);
  if (notChecked === bombAmount) {
      result.innerHTML = 'YOU WIN!'
      isGameOver = true;
      const audio = new Audio(import.meta.env.VITE_SCOPE + 'win.mp3');
      audio.play(); 
  }
}

function help() {
  //show ALL the bombs
  squares.forEach(square => {
    if (square.classList.contains('minesweeper-bomb')) {
      square.innerHTML = '☕️'
      square.classList.remove('minesweeper-bomb')
      square.classList.add('minesweeper-help')
      square.classList.add('minesweeper-checked')
    }
  })

  //hide ALL the bombs
  setTimeout(() => {
    squares.forEach(square => {
      if (square.classList.contains('minesweeper-help')) {
        square.innerHTML = ''
        square.classList.remove('minesweeper-help')
        square.classList.remove('minesweeper-checked')
        square.classList.add('minesweeper-bomb')
      }
    });
  }, 500);
}

export { PRICE, createBoard, help };